import { WishlistItemSchema } from "@apps/wishlist/schemas/WishlistItemSchema";
import { object } from "superstruct";

export const UpdateItemVariantResponseSchema = object({
    updatedWishlistItem: WishlistItemSchema,
});
